import { StrictOmit } from '@enmon/commons';
import { message } from 'antd';
import { MessageInstance } from 'antd/lib/message';

export const useAppMessages = (): StrictOmit<MessageInstance, 'open' | 'loading'> => ({
  success: (content: string) => message.success(content),
  info: (content: string) => message.info(content),
  warning: (content: string) => message.warning(content),
  error: (content: string) => message.error(content),
});
